import { create } from 'zustand'

type DrawerStore = {
  drawers: Record<string, boolean>
  openDrawer: (id: string) => void
  closeDrawer: (id: string) => void
  toggleDrawer: (id: string) => void
}

export const useDrawerStore = create<DrawerStore>(set => ({
  drawers: {},
  toggleDrawer: id => {
    set(state => ({
      drawers: {
        ...state.drawers,
        [id]: !state.drawers[id]
      }
    }))
  },
  openDrawer: id => {
    set(state => ({
      drawers: {
        ...state.drawers,
        [id]: true
      }
    }))
  },
  closeDrawer: id => {
    set(state => ({
      drawers: {
        ...state.drawers,
        [id]: false
      }
    }))
  }
}))
